import React from 'react'
import HomeWeServeItem from './HomeWeServeItem'

const HomeWeServeList = ({ serviceList, activeServiced, changeActiveServiced }) => {
  return (
    <ul className="dealmed-home-serve__list">
      {serviceList.map((serviced, index) => {
        return (
          <HomeWeServeItem
            key={index}
            serviced={serviced}
            isActive={activeServiced === serviced}
            changeActiveServiced={changeActiveServiced}
          />
        )
      })}
    </ul>
  )
}

export default HomeWeServeList
